import { render } from "./LoginLayout.vue?vue&type=template&id=24808dc9&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./login-layout.scss?vue&type=style&index=0&id=24808dc9&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24808dc9"]])

export default __exports__